export const Paths = {
  upload: `/upload`,
};
